var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1079.5,
    fill: "#B8E4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1072.48 626.019C675.101 546.957 351.784 620.449 100.444 668.1V961.432L1898.24 990.518V540C1790.86 592.602 1483.05 707.706 1072.48 626.019Z",
    fill: "#B8E4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M793.279 677.384C396.885 755.829 240.984 725.464 0 677.384V1019H1920V604C1751.8 815.929 1124.26 611.883 793.279 677.384Z",
    fill: "#98D5ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M861.234 740.73C720.405 773.863 252.13 847.907 0.0439608 762.152L-6.69606e-06 990.199L1919.82 990.861L1919.87 741.095C1829.76 752.526 1682.82 791.087 1442.73 791.004C1350.17 790.972 1011.52 705.373 861.234 740.73Z",
    fill: "#50A0BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M857.429 824.961C537.833 944.948 258.974 873.203 0 837.949V1021.64L1920 1047V888.665C1698.85 978.347 1125.13 724.455 857.429 824.961Z",
    fill: "#025373"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1176.89 1000.52C901.954 926.874 221.631 847.721 0 1010.28V1080H1920V934.157C1802.87 952.038 1406.82 1062.12 1176.89 1000.52Z",
    fill: "#023859"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBlue);
export default __webpack_public_path__ + "static/media/bgBlue.5d8e3fe6b1704537b9775d41b1d6cd3a.svg";
export { ForwardRef as ReactComponent };